import React, { useEffect, useState } from 'react';
import { Button, Grid, TextField, DialogTitle, Dialog, DialogActions, DialogContent, DialogContentText, FormControl, Divider, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import SaveIcon from '@mui/icons-material/Save';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';
import Alert from '@mui/material/Alert';
import ProjectUpdate from './ProjectUpdate';
import ProjectSummaryList from './ProjectSummaryList';
import HavcRadioOption from './HavcRadioOption';
import CheckIcon from '@mui/icons-material/Check';

const SessionUser = getUser();

const initialFormState = {
  ProjectOwner: '',
  ProjectAddress: '',
  ServiceId: '',
  MentorServiceId: '',
  DealerId: '',
  DerivationFrom: -1,
  DistrictId: -1,
  DraftProject: 1,
  FreshAirCount: 0,
  PdiCount: 0,
  HeatPumpCount: 0,
  NeighbourhoodId: -1,
  BrandId: 0,
  RegionId: '',
  CityId: -1,
  CustomerName: '',
  CustomerSurname: '',
  CustomerTel1: '',
  CustomerTel2: '',
  CustomerTel3: '',
  ProjectTotalOduCount: 0,
  ProjectTotalIduCount: 0,
  ProjectTotalGasAmount: 0,
  ControlRoomCount: 0,
  SystemCount: 0,
  RegistrationDate: '01.01.2023',
  ResponsibleTechnicianId: '',
  ServiceManagerId: '',
  DealerManagerId: '',
  Description: '',
  Modifier: SessionUser?.UserId ? SessionUser?.UserId : '0',
  Active: 1
};
//log 
const getObjectDifferences = (initialObj, currentObj) => {
  const diffs = [];
  Object.keys(currentObj).forEach(key => {
    if (initialObj[key] !== currentObj[key]) {
      diffs.push({
        oldValue: initialObj[key],
        newValue: currentObj[key],
        key: key,
        id: null,
        fisNo: null
      });
    }
  });
  return diffs;
};


const getFilesDifferences = (initialFiles, currentFiles) => {
  const diffs = [];
  // Silinen veya değişen dosyalar
  initialFiles.forEach(initFile => {
    const match = currentFiles.find(f => f.id === initFile.id);
    if (!match || match.active === 0) {
      diffs.push({
        oldValue: initFile.fileName,
        newValue: null,
        key: 'fileName',
        id: initFile.id,
        fisNo: null
      });
    } else {
      Object.keys(initFile).forEach(key => {
        if (initFile[key] !== match[key]) {
          diffs.push({
            oldValue: initFile[key],
            newValue: match[key],
            key: 'fileType',
            id: initFile.id,
            fisNo: null
          });
        }
      });
    }
  });
  // Eklenen dosyalar
  currentFiles.forEach(curFile => {
    if (!initialFiles.find(f => f.id === curFile.id)) {
      diffs.push({
        oldValue: null,
        newValue: curFile.fileName,
        key: 'fileName',
        id: curFile.id,
        fisNo: null
      });
    }
  });
  return diffs;
};
const getArrayDifferences = (initialArr, currentArr, key = 'Id') => {
  const diffs = [];
  // Silinen ve değişenler
  initialArr.forEach(initItem => {
    const match = currentArr.find(item => item[key] === initItem[key]);
    if (!match) {
      diffs.push({
        oldValue: initItem.Id,
        newValue: null,
        key: 'Id',
        id: initItem.Id,
        fisNo: null
      });
    } else {
      Object.keys(initItem).forEach(field => {
        if (initItem[field] !== match[field] && field !== "LineStatus") {
          diffs.push({
            oldValue: initItem[field],
            newValue: match[field],
            key: field,
            id: initItem.Id,
            fisNo: null
          });
        }
      });
    }
  });
  // Eklenenler
  currentArr.forEach(curItem => {
    if (!initialArr.find(item => item[key] === curItem[key])) {
      diffs.push({
        oldValue: null,
        newValue: curItem.Id,
        key: 'Id',
        id: curItem.Id,
        fisNo: null
      });
    }
  });
  return diffs;
};

const getUpdateFormData = (formData) => ({
  ProjectID: formData.ProjectID,
  ProjectOwner: formData.ProjectOwner,
  ProjectAddress: formData.ProjectAddress,
  BrandId: formData.BrandId,
  ResponsibleTechnicianId: formData.ResponsibleTechnicianId,
  CityId: formData.CityId,
  ControlRoomCount: formData.ControlRoomCount,
  CustomerName: formData.CustomerName,
  CustomerSurname: formData.CustomerSurname,
  CustomerTel1: formData.CustomerTel1,
  CustomerTel2: formData.CustomerTel2,
  CustomerTel3: formData.CustomerTel3,
  DealerId: formData.DealerId,
  DealerManagerId: formData.DealerManagerId,
  Description: formData.Description,
  DistrictId: formData.DistrictId,
  DraftProject: formData.DraftProject,
  FreshAirCount: formData.FreshAirCount,
  HeatPumpCount: formData.HeatPumpCount,
  MentorServiceId: formData.MentorServiceId,
  NeighbourhoodId: formData.NeighbourhoodId,
  PdiCount: formData.PdiCount,
  RegionId: formData.RegionId,
  RegistrationDate: formData.RegistrationDate,
  ServiceId: formData.ServiceId,
  ServiceManagerId: formData.ServiceManagerId,
  SystemCount: formData.SystemCount,
  TotalOdu: formData.TotalOdu,
  TotalIdu: formData.TotalIdu,
  //Modifier: formData.Modifier
});
//log

function UpdateProjectDialog({
  open,
  setOpen,
  selectedRow,
  setSelectedRow,
  HavcAddressData,
  sorgula,
  onUpdateSuccess
}) {
  //log
  const [dataInitial, setDataInitial] = useState([]);
  const [formDataInitial, setFormDataInitial] = useState(null);
  const [projectFilesInitial, setProjectFilesInitial] = useState([]);
  //log
  const currentUser = SessionUser?.UserId ? SessionUser?.UserId : "0";
  initialFormState.Modifier = SessionUser?.UserId ? SessionUser?.UserId : "0"; //büyük ihtimalle race condition oluyor yukarda.
  const [formData, setFormData] = useState(initialFormState);
  const [formDataMinValues, setFormDataMinValues] = useState(initialFormState);
  const [durum, setDurum] = React.useState([]);
  const [bolge, setBolge] = React.useState([]);
  const [servis, setServis] = React.useState([]);
  const [bayi, setBayi] = React.useState([]);
  const [mentorServis, setMentorServis] = React.useState([]);
  const [il, setIl] = React.useState([]);
  const [ilce, setIlce] = React.useState([]);
  const [mahalle, setMahalle] = React.useState([]);
  const [marka, setMarka] = React.useState([]);
  const [merkeziKlima, setMerkemziKlima] = React.useState([]);
  const [servisYonetmeni, setServisYonetmeni] = React.useState([]);
  const [sorumluTeknisyen, setSorumluTeknisyen] = React.useState([]);
  const [data, setData] = useState([]);
  const [projectFiles, setProjectFiles] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [exceptionalUsers, setExceptionalUsers] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [fileLoading, setFileLoading] = React.useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [projectSummary, setProjectSummary] = React.useState(false);
  const [errors, setErrors] = useState({
    CustomerName: '',
    CustomerSurname: '',
    CityId: '',
    CustomerTel1: '',
    CustomerTel2: '',
    DistrictId: '',
    NeighbourhoodId: '',
    ServiceId: ''
  });
  const [phoneRegionCodes, setPhoneRegionCodes] = React.useState([]);

  const validateForm = () => {
    let tempErrors = { ...errors };
    let isValid = true;

    tempErrors.CustomerName = '';
    tempErrors.CustomerSurname = '';
    tempErrors.CustomerTel1 = '';
    tempErrors.CustomerTel2 = '';
    tempErrors.CustomerTel3 = '';
    tempErrors.CityId = '';
    tempErrors.DistrictId = '';
    tempErrors.NeighbourhoodId = '';
    tempErrors.ServiceId = '';
    tempErrors.RegionId = '';

    if (!formData.CustomerName) {
      tempErrors.CustomerName = 'Müşteri Adı gerekli';
      isValid = false;
    }
    if (!formData.CustomerSurname) {
      tempErrors.CustomerSurname = 'Müşteri Soyadı gerekli';
      isValid = false;
    }
    if (!formData.CustomerTel1) {
      tempErrors.CustomerTel1 = 'Tel1 gerekli';
      isValid = false;
    }
    else if (formData.CustomerTel1.length !== 10) {
      tempErrors.CustomerTel1 = 'Tel1 no 10 haneli bir sayı olmalı';
      isValid = false;
    } else if (/\s/.test(formData.CustomerTel1)) {
      tempErrors.CustomerTel1 = 'Tel1 no boşluk içeremez';
      isValid = false;
    } else if (formData.CustomerTel1.startsWith('0')) {
      tempErrors.CustomerTel1 = 'Tel1 no sıfır ile başlayamaz';
      isValid = false;
    } else if (
      !phoneRegionCodes.some(
        x => x.Dsc === formData.CustomerTel1.substring(0, 3)
      )
    ) {
      tempErrors.CustomerTel1 = 'Tel1 no formatını kontrol ediniz';
      isValid = false;
    }
    // if (!formData.CustomerTel2) {
    //   tempErrors.CustomerTel2 = 'Tel2 gerekli';
    //   isValid = false;
    // }
    if (formData.CityId < 0 || formData.CityId == null) {
      tempErrors.CityId = 'İl seçimi gerekli';
      isValid = false;
    }
    if (formData.DistrictId < 0 || formData.DistrictId == null) {
      tempErrors.DistrictId = 'İlçe seçimi gerekli';
      isValid = false;
    }
    if (formData.NeighbourhoodId < 0 || formData.NeighbourhoodId == null) {
      tempErrors.NeighbourhoodId = 'Mahalle seçimi gerekli';
      isValid = false;
    }
    if (!formData.RegionId) {
      tempErrors.RegionId = 'Bölge seçimi gerekli';
      isValid = false;
    }
    if (!formData.ServiceId) {
      tempErrors.ServiceId = 'Servis seçimi gerekli';
      isValid = false;
    }
    /*
    data
      .filter(x => x.Level === 1 && x.LineStatus !== 'D')
      .forEach((item, index) => {
        if (!item.OduCount || item.OduCount <= 0) {
          tempErrors[`OduCount${item.Id}`] = 'Dış Ünite Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`OduCount${item.Id}`] = '';
        }
        if (!item.IduCount || item.IduCount <= 0) {
          tempErrors[`IduCount${item.Id}`] = 'İç Ünite Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`IduCount${item.Id}`] = '';
        }
        if (!item.HydrocideCount || item.HydrocideCount <= 0) {
          tempErrors[`HydrocideCount${item.Id}`] = 'Hidrokit Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`HydrocideCount${item.Id}`] = '';
        }
        if (!item.RemoteCount || item.RemoteCount <= 0) {
          tempErrors[`RemoteCount${item.Id}`] = 'Kumanda Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`RemoteCount${item.Id}`] = '';
        }
        if (!item.FrontPanelCount || item.FrontPanelCount <= 0) {
          tempErrors[`FrontPanelCount${item.Id}`] = 'Ön Panel Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`FrontPanelCount${item.Id}`] = '';
        }
        if (!item.HrBoxCount || item.HrBoxCount <= 0) {
          tempErrors[`HrBoxCount${item.Id}`] = 'Hr BOX Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`HrBoxCount${item.Id}`] = '';
        }
        if (!item.IntegrationModuleCount || item.IntegrationModuleCount <= 0) {
          tempErrors[`IntegrationModuleCount${item.Id}`] =
            'Entegrasyon Modül Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`IntegrationModuleCount${item.Id}`] = '';
        }
        if (
          !item.KsCommunicationKitCount ||
          item.KsCommunicationKitCount <= 0
        ) {
          tempErrors[`KsCommunicationKitCount${item.Id}`] =
            'Ks Haberleşme Kit Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`KsCommunicationKitCount${item.Id}`] = '';
        }
        if (!item.EevKitCount || item.EevKitCount <= 0) {
          tempErrors[`EevKitCount${item.Id}`] = 'Eev Kit Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`EevKitCount${item.Id}`] = '';
        }
        if (!item.FdxBoxCount || item.FdxBoxCount <= 0) {
          tempErrors[`FdxBoxCount${item.Id}`] = 'Fdx Box Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`FdxBoxCount${item.Id}`] = '';
        }
        if (!item.AirRouterCount || item.AirRouterCount <= 0) {
          tempErrors[`AirRouterCount${item.Id}`] =
            'Hava Yönlendirici Adet Girilmeli';
          isValid = false;
        } else {
          tempErrors[`AirRouterCount${item.Id}`] = '';
        }
      });
*/
    setErrors(tempErrors);
    return isValid;
  };

  const testFunc = () => {
    console.clear();
    console.log(formData);
    console.log(data);
    console.log(projectFiles);
  };

  const checkRolesAuth = field => {
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user?.UserId;
    let roleId = user?.Role_Id;

    if (exceptionalUsers.filter(x => x.Id === userId).length > 0) {
      roleId = 15;
    }

    const roleCheck =
      permissions.filter(
        x =>
          x.HavcPage === 'UpdateProjectDialog' &&
          x.ApolloRoleId === roleId &&
          x.HavcField === field
      ).length > 0
        ? true
        : false;
    return roleCheck;
  };

  const getLabel = (pID, currentLevel, i) => {
    const maxId =
      data
        .filter(x => x.LineStatus !== 'D')
        .reduce((max, item) => (item.Id > max ? item.Id : max), 0) + i;

    const count =
      data.filter(x => x.Level === 1 && x.LineStatus !== 'D').length + 1;

    switch (currentLevel) {
      case 0:
        return `Merkezi Kumanda-${parseInt(count)}`;
      case 1:
        return `Sistem-${parseInt(count)}`;
      case 2:
        return `ODU-${parseInt(count)}`;
      case 3:
        return `IDU-${parseInt(count)}`;
      default:
        return `Label-${count}`;
    }
  };

  useEffect(() => {
    if (selectedRow) {
      setFormData(prevData => ({
        ...prevData,
        ...selectedRow
      }));
      setFormDataMinValues(prevData => ({
        ...prevData,
        ...selectedRow
      }));
      setFormDataInitial({ ...initialFormState, ...selectedRow }); //log icin
    }

    // Dosya loading state'ini başlat
    setFileLoading(true);

    // Project Details API çağrısı
    axios
      .get(`GetHavcProjectDetails/${selectedRow.ProjectID}`)
      .then(response => {
        setData(response.data ? response.data : []);
        setDataInitial(response.data ? response.data : []); //log icin
      })
      .catch(error => {
        console.log('Project details yüklenirken hata oluştu:', error);
      });

    // Project Files API çağrısı
    axios
      .get(`GetHavcProjectFiles/${selectedRow.ProjectID}`)
      .then(response => {
        setProjectFiles(response.data ? response.data : []);
        setProjectFilesInitial(response.data ? JSON.parse(JSON.stringify(response.data)) : []); //log icin
      })
      .catch(error => {
        console.log('Dosyalar yüklenirken hata oluştu:', error);
      })
      .finally(() => {
        // API başarılı veya hatalı olsa da loading state'i kapat
        setFileLoading(false);
      });
  }, [selectedRow]);

  useEffect(() => {
    try {
      const mainArray = JSON.parse(
        localStorage.getItem('HavcComboData').replace(/\\"/g, '"')
      );

      setDurum(mainArray[0].DURUM);
      setBolge(mainArray[0].BOLGE);
      setServis(mainArray[0].SERVIS);
      setBayi(mainArray[0].BAYI);
      setMentorServis(mainArray[0].MENTOR_SERVIS);
      setMarka(mainArray[0].MARKA);
      setMerkemziKlima(mainArray[0].MERKEZI_KLIMALAR);
      setServisYonetmeni(mainArray[0].SERVIS_YONETMENI);
      setSorumluTeknisyen(mainArray[0].SORUMLU_TEKNISYEN);
      setIl(HavcAddressData[0]?.IL);
      setIlce(HavcAddressData[0]?.ILCE);
      setMahalle(HavcAddressData[0]?.MAHALLE);
      setPermissions(mainArray[0].ROLES);
      setExceptionalUsers(mainArray[0]?.EXUSERS);
      setPhoneRegionCodes(mainArray[0].PHONE_REGION_CODES);
    } catch (error) {
      console.log('Bir hata oluştu.');
    }
  }, []);

  const handleAutocompleteSelect = property => (event, newValue) => {
    if (property === 'CityId') {
      formData.DistrictId = null;
      formData.NeighbourhoodId = null;
    }
    if (property === 'DistrictId') {
      formData.NeighbourhoodId = null;
    }

    setFormData(prevData => ({
      ...prevData,
      [property]: newValue ? newValue.Id : null,
      LineStatus: 'U'
    }));
  };

  const handleInputChange = (e, prop, newVal, level, minVal, parentID) => {
    let { name, value } = e.target;
    value =
      name === 'DraftProject'
        ? e.target.checked === true
          ? 1
          : 0
        : e.target.value;

    setFormData(prevData => ({ ...prevData, [name]: value, LineStatus: 'U' }));

    if (
      (prop === 'decreaseControl' ||
        name === 'ControlRoomCount' ||
        name === 'SystemCount') &&
      parseInt(value) < parseInt(minVal)
    ) {
      setFormData(prevData => ({
        ...prevData,
        [name]: formData.DraftProject == 0 ? minVal : value,
        LineStatus: 'N'
      }));
    }

    const lastElementId = Math.max(
      ...data
        .filter(item => item.Level === level && item.LineStatus !== 'D')
        .map(item => item.Id),
      0
    );

    const selectedItem = data.filter(
      x => x.Level === level && x.LineStatus !== 'D'
    )[0];

    if (prop === 'ChildCount') {
      let newValue;
      if (newVal) {
        newValue = newVal?.Id ? newVal?.Id : newVal;
      }

      const lastVal = parseInt(
        data.filter(x => x.Level === level && x.LineStatus !== 'D').length
      );
      const newValInt = parseInt(newVal);

      if (lastVal > parseInt(newVal)) {
        // if (level === 0) {
        //   setFormData(prevData => ({
        //     ...prevData,
        //     ControlRoomCount: newVal,
        //     SystemCount: newValInt === 0 ? newValInt : formData.SystemCount,
        //     LineStatus: 'U'
        //   }));
        // } else {
        //   setFormData(prevData => ({
        //     ...prevData,
        //     SystemCount: newVal,
        //     LineStatus: 'U'
        //   }));
        // }

        const idsToDelete = data
          .filter(
            item => item.Level === level && (item.DerivationFrom === parentID //dbden gelenleri silmek için -1 onlar
              || (item.ParentID !== undefined && item.ParentID === 0)) //sayfada oluşturulanları silmek için
              && item.LineStatus !== 'D'
          )
          .sort((a, b) => b.Id - a.Id)
          .slice(0, lastVal - (newValInt < minVal ? (formData.DraftProject == 0 ? minVal : newValInt) : newValInt))
          .map(item => ({ Id: item.Id, LineStatus: item.LineStatus }));

        idsToDelete.forEach(item =>
          handleDelete(item.Id, prop, newValue, item.LineStatus)
        );
      } else {
        const arrLength =
          parseInt(newVal) -
          data.filter(x => x.Level === level && x.LineStatus !== 'D').length;
        const newElementId =
          data && data.length > 0
            ? Math.max(...data.map(item => item.Id, 0)) + 1
            : 1;
        const newObjects = Array.from(
          { length: parseInt(arrLength) },
          (_, index) => ({
            Id: newElementId + index + 1,
            ProjectID: selectedItem?.ProjectID
              ? selectedItem?.ProjectID
              : selectedRow.ProjectID,
            AdditionalGasAmount: 0.0,
            AirRouterCount: 0,
            BranchCollectorCount: 0,
            Cable12_7mm: 0.0,
            Cable15_88mm: 0.0,
            Cable19_05mm: 0.0,
            Cable22_22mm: 0.0,
            Cable25_4mm: 0.0,
            Cable28_88mm: 0.0,
            Cable34_92mm: 0.0,
            Cable41_28mm: 0.0,
            Cable6_35mm: 0.0,
            Cable9_52mm: 0.0,
            CommissioningDate: '',
            ControlRoomModel: 0,
            ControlRoomModelNote: '',
            Creator: SessionUser?.UserId ? SessionUser?.UserId : '0',
            DerivationFrom: 0,
            DryContactCount: 0,
            DxCount: 0,
            EevKitCount: 0,
            FdxBoxCount: 0,
            FreshAirCount: 0,
            FreshAirDxCount: 0,
            FrontPanelCount: 0,
            HrBoxCount: 0,
            HydrocideCount: 0,
            IduCount: 0,
            IntegrationModuleCount: 0,
            KsCommunicationKitCount: 0,
            KsDxCount: 0,
            Level: selectedItem?.Level ? selectedItem?.Level : level,
            LineStatus: 'A',
            Modifier: SessionUser?.UserId ? SessionUser?.UserId : '0',
            OduCount: 0,
            PreGasAmount: 0.0,
            ParentID: selectedItem?.ParentID ? selectedItem?.ParentID : 0,
            ProjectID: selectedItem?.ProjectID
              ? selectedItem?.ProjectID
              : selectedRow.ProjectID,
            RemoteCount: 0,
            SystemCapacity: 0.0,
            SystemControlRoomModel: 0,
            SystemName: getLabel(0, level, index),
            SystemNote: '',
            SystemRepeatCount: 1,
            SystemStatus: 0,
            SystemTotalGas: 0.0,
            ContractDate: ''
          })
        );

        setData(prev => [...prev, ...newObjects]);
      }
    } else {
      setData(prevData =>
        prevData.map(item =>
          item.Id === lastElementId
            ? {
              ...item,
              [prop]: newValue,
              LineStatus: item.LineStatus === 'A' ? 'A' : 'U'
            }
            : item
        )
      );
    }
  };

  const handleDelete = (parentId, porp, newValue, status) => {
    const deleteNode = id => {
      if (status !== 'A') {
        setData(prevData =>
          prevData.map(item =>
            item.Id === id
              ? {
                ...item,
                ChildCount: newValue,
                LineStatus: 'D'
              }
              : item
          )
        );
      } else {
        setData(prevData => prevData.filter(item => item.Id !== id));
        const children = data.filter(item => item.DerivationFrom === id);
        children.forEach(child => deleteNode(child.Id));
      }

      const children = data.filter(item => item.DerivationFrom === id);
      children.forEach(child => deleteNode(child.Id));
    };

    const parentNode = data.find(item => item.Id === parentId);
    if (parentNode) {
      deleteNode(parentId);
    }
  };

  const setKaydet = () => {
    if (!validateForm()) {
      setShowAlert(true);
      return;
    }
    if (!loading) {
      setLoading(true);
    }

    const updateFormData = {
      ProjectID: formData.ProjectID,
      ProjectOwner: formData.ProjectOwner,
      ProjectAddress: formData.ProjectAddress,
      BrandId: formData.BrandId,
      ResponsibleTechnicianId: formData.ResponsibleTechnicianId,
      CityId: formData.CityId,
      ControlRoomCount: formData.ControlRoomCount,
      CustomerName: formData.CustomerName,
      CustomerSurname: formData.CustomerSurname,
      CustomerTel1: formData.CustomerTel1,
      CustomerTel2: formData.CustomerTel2,
      CustomerTel3: formData.CustomerTel3,
      DealerId: formData.DealerId,
      DealerManagerId: formData.DealerManagerId,
      Description: formData.Description,
      DistrictId: formData.DistrictId,
      DraftProject: formData.DraftProject,
      FreshAirCount: formData.FreshAirCount,
      HeatPumpCount: formData.HeatPumpCount,
      MentorServiceId: formData.MentorServiceId,
      NeighbourhoodId: formData.NeighbourhoodId,
      PdiCount: formData.PdiCount,
      RegionId: formData.RegionId,
      RegistrationDate: formData.RegistrationDate.split('T')[0],
      ServiceId: formData.ServiceId,
      ServiceManagerId: formData.ServiceManagerId,
      SystemCount: formData.SystemCount,
      TotalOdu: formData.TotalOdu,
      TotalIdu: formData.TotalIdu,
      Modifier: formData.Modifier,
      ContractDate: formData?.ContractDate?.split('T')[0],
    };
    let formDataArray = [];
    formDataArray.push(updateFormData);
    const FilesData = projectFiles.map(file => ({
      id: file.id,
      fileType: file.fileType,
      fileData: file.fileData,
      fileName: file.fileName,
      fileSystem: file.fileSystem,
      active: file.active,
      fromDb: file.fromDb
    }));
    //log      
    const initialUpdateFormData = getUpdateFormData(formDataInitial || {});
    const finalUpdateFormData = getUpdateFormData(formData || {});
    const formDiffs = getObjectDifferences(initialUpdateFormData, finalUpdateFormData);
    const filesDiffs = getFilesDifferences(projectFilesInitial || [], projectFiles);
    const dataDiffs = getArrayDifferences(dataInitial || [], data || []);
    const changes = formDiffs.concat(filesDiffs, dataDiffs);
    const changesWithProjectId = changes.map(item => ({
      ...item,
      ProjectID: updateFormData.ProjectID
    }));
    //log
    const body = {
      header: formDataArray,
      detail: data,
      files: FilesData
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios
      .post('HavcProjectUpdate', body, config)
      .then(response => {
        axios.post('SetHavcProjectLog', changesWithProjectId, config);
        setData([]);
        setFormData(initialFormState);
        setSelectedRow([]);
        setProjectFiles([]);
        setErrors([]);
        setLoading(false);
        setShowAlert(false);
        setOpen(false);
        onUpdateSuccess(selectedRow.ProjectID);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const handleDialogClose = () => {
    setData([]);
    setFormData(initialFormState);
    setSelectedRow([]);
    setProjectFiles([]);
    setErrors([]);
    setLoading(false);
    setShowAlert(false);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="lg"
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          setOpen(false);
        }
      }}
    >
      <DialogTitle>HVAC ve Enerji Çözümleri Proje Görüntüleme</DialogTitle>
      <DialogContent>
        {HavcAddressData?.length > 0 ? (
          <Grid container spacing={2}>
            <Grid size={4}>
              <FormControl fullWidth>
                <TextField
                  autoFocus
                  type="text"
                  placeholder="Proje Adı"
                  variant="outlined"
                  name="ProjectOwner"
                  value={formData.ProjectOwner}
                  onChange={handleInputChange}
                  disabled={!checkRolesAuth('ProjectOwner')}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <TextField
                  autoFocus
                  type="text"
                  placeholder="Müşteri Adı"
                  variant="outlined"
                  disabled={!(formData.DraftProject ? true : false && checkRolesAuth('ServiceId'))}
                  name="CustomerName"
                  error={Boolean(errors.CustomerName)}
                  helperText={errors.CustomerName}
                  value={formData.CustomerName}
                  onChange={handleInputChange}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <TextField
                  autoFocus
                  type="text"
                  placeholder="Müşteri Soyadı"
                  variant="outlined"
                  disabled={!(formData.DraftProject ? true : false && checkRolesAuth('ServiceId'))}
                  name="CustomerSurname"
                  error={Boolean(errors.CustomerSurname)}
                  helperText={errors.CustomerSurname}
                  value={formData.CustomerSurname}
                  onChange={handleInputChange}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <TextField
                  autoFocus
                  type="text"
                  placeholder="Müşteri Tel1"
                  variant="outlined"
                  disabled={!(formData.DraftProject ? true : false && checkRolesAuth('ServiceId'))}
                  name="CustomerTel1"
                  error={Boolean(errors.CustomerTel1)}
                  helperText={errors.CustomerTel1}
                  value={formData.CustomerTel1}
                  onChange={handleInputChange}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <TextField
                  autoFocus
                  type="text"
                  placeholder="Müşteri Tel2"
                  variant="outlined"
                  disabled={!(formData.DraftProject ? true : false && checkRolesAuth('ServiceId'))}
                  name="CustomerTel2"
                  error={Boolean(errors.CustomerTel2)}
                  helperText={errors.CustomerTel2}
                  value={formData.CustomerTel2}
                  onChange={handleInputChange}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <TextField
                  autoFocus
                  type="text"
                  placeholder="Müşteri Tel3"
                  variant="outlined"
                  disabled={!(formData.DraftProject ? true : false && checkRolesAuth('ServiceId'))}
                  name="CustomerTel3"
                  value={formData.CustomerTel3}
                  onChange={handleInputChange}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <Autocomplete
                  id="CityId"
                  name="CityId"
                  fullWidth
                  disabled={!(formData.DraftProject ? true : false && checkRolesAuth('ServiceId'))}
                  options={HavcAddressData[0]?.IL}
                  getOptionLabel={il => (il.Dsc ? il.Dsc : '')}
                  value={HavcAddressData[0]?.IL?.find(
                    x => x.Id == String(formData?.CityId)?.trim()
                  )}
                  onChange={handleAutocompleteSelect('CityId')}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="İl"
                      variant="outlined"
                      error={Boolean(errors.CityId)}
                      helperText={errors.CityId}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <Autocomplete
                  id="DistrictId"
                  name="DistrictId"
                  fullWidth
                  disabled={!(formData.DraftProject ? true : false && checkRolesAuth('ServiceId'))}
                  options={HavcAddressData[0]?.ILCE.filter(
                    item => parseInt(item.IlId) === parseInt(formData.CityId)
                  )}
                  getOptionLabel={ilce => (ilce.Dsc ? ilce.Dsc : '')}
                  value={HavcAddressData[0]?.ILCE?.find(
                    x =>
                      x.Id === formData.DistrictId &&
                      parseInt(x.IlId) === parseInt(formData.CityId)
                  )}
                  onChange={handleAutocompleteSelect('DistrictId')}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="İlçe"
                      variant="outlined"
                      error={Boolean(errors.DistrictId)}
                      helperText={errors.DistrictId}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <Autocomplete
                  id="NeighbourhoodId"
                  name="NeighbourhoodId"
                  fullWidth
                  disabled={!(formData.DraftProject ? true : false && checkRolesAuth('ServiceId'))}
                  options={HavcAddressData[0]?.MAHALLE.filter(
                    item =>
                      parseInt(item.IlId) === parseInt(formData.CityId) &&
                      item.IlceId === formData.DistrictId
                  )}
                  getOptionLabel={mahalle => (mahalle.Dsc ? mahalle.Dsc : '')}
                  value={HavcAddressData[0]?.MAHALLE?.find(
                    x => x.Id === formData.NeighbourhoodId
                  )}
                  onChange={handleAutocompleteSelect('NeighbourhoodId')}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Mahalle"
                      variant="outlined"
                      error={Boolean(errors.NeighbourhoodId)}
                      helperText={errors.NeighbourhoodId}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <Autocomplete
                  id="RegionId"
                  name="RegionId"
                  fullWidth
                  disabled={!(formData.DraftProject ? true : false && checkRolesAuth('ServiceId'))}
                  options={bolge}
                  getOptionLabel={bolge => (bolge.Dsc ? bolge.Dsc : '')}
                  value={bolge?.find(x => x.Id == formData.RegionId)}
                  onChange={handleAutocompleteSelect('RegionId')}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Bölge"
                      variant="outlined"
                      error={Boolean(errors.RegionId)}
                      helperText={errors.RegionId}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <Autocomplete
                  id="ServiceId"
                  name="ServiceId"
                  fullWidth
                  disabled={!(formData.DraftProject ? true : false && checkRolesAuth('ServiceId'))}
                  options={servis}
                  getOptionLabel={servis => (servis.Dsc ? servis.Dsc : '')}
                  value={servis?.find(x => x.Id == formData.ServiceId)}
                  onChange={handleAutocompleteSelect('ServiceId')}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Servis"
                      variant="outlined"
                      error={Boolean(errors.ServiceId)}
                      helperText={errors.ServiceId}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <Autocomplete
                  id="MentorServiceId"
                  name="MentorServiceId"
                  fullWidth
                  disabled={!checkRolesAuth('MentorServiceId')}
                  options={mentorServis}
                  value={
                    mentorServis?.find(x => x.Id == formData.MentorServiceId) ||
                    null
                  }
                  getOptionLabel={mentorServis =>
                    mentorServis.Dsc ? mentorServis.Dsc : ''
                  }
                  onChange={handleAutocompleteSelect('MentorServiceId')}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Proje Destek Servisi"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <Autocomplete
                  id="DealerId"
                  name="DealerId"
                  fullWidth
                  disabled={!checkRolesAuth('DealerId')}
                  options={bayi}
                  getOptionLabel={bayi => (bayi.Dsc ? bayi.Dsc : '')}
                  value={bayi?.find(x => x.Id == formData.DealerId)}
                  onChange={handleAutocompleteSelect('DealerId')}
                  renderInput={params => (
                    <TextField {...params} label="Bayi" variant="outlined" />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <Autocomplete
                  id="BrandId"
                  name="BrandId"
                  fullWidth
                  disabled={!checkRolesAuth('BrandId')}
                  options={marka}
                  getOptionLabel={marka => (marka.Dsc ? marka.Dsc : '')}
                  value={marka?.find(x => x.Id == formData.BrandId)}
                  onChange={handleAutocompleteSelect('BrandId')}
                  renderInput={params => (
                    <TextField {...params} label="Marka" variant="outlined" />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <Autocomplete
                  id="ResponsibleTechnicianId"
                  name="ResponsibleTechnicianId"
                  fullWidth
                  disabled={!checkRolesAuth('ResponsibleTechnicianId')}
                  options={sorumluTeknisyen}
                  getOptionLabel={teknisyen =>
                    teknisyen.Dsc ? teknisyen.Dsc : ''
                  }
                  value={sorumluTeknisyen?.find(
                    x => x.Id == formData.ResponsibleTechnicianId
                  )}
                  onChange={handleAutocompleteSelect('ResponsibleTechnicianId')}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Sorumlu Teknisyen"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <Autocomplete
                  id="ServiceManagerId"
                  name="ServiceManagerId"
                  fullWidth
                  disabled={!checkRolesAuth('ServiceManagerId')}
                  options={servisYonetmeni}
                  getOptionLabel={yonetmen =>
                    yonetmen.Dsc ? yonetmen.Dsc : ''
                  }
                  value={servisYonetmeni?.find(
                    x => x.Id == formData.ServiceManagerId
                  )}
                  onChange={handleAutocompleteSelect('ServiceManagerId')}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Servis Yönetmeni"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <TextField
                  variant="outlined"
                  type="text"
                  label="Bayi Yönetmeni"
                  name="DealerManagerId"
                  disabled={!checkRolesAuth('DealerManagerId')}
                  value={formData.DealerManagerId}
                  onChange={handleInputChange}
                />
              </FormControl>
            </Grid>
            <Grid size={4}>
              <FormControl fullWidth>
                <TextField
                  label="Kayıt Tarihi"
                  variant="outlined"
                  type="date"
                  disabled={!checkRolesAuth('RegistrationDate')}
                  InputLabelProps={{ shrink: true, required: true }}
                  name="RegistrationDate"
                  value={formData.RegistrationDate.split('T')[0]}
                  onChange={handleInputChange}
                />
              </FormControl>
            </Grid>
            <Grid size={12}>
              <Divider />
            </Grid>
            <Grid size={12}>
              <FormControl fullWidth>
                <TextField
                  id="ProjectAddress"
                  name="ProjectAddress"
                  label="Açık Adres"
                  variant="outlined"
                  type="text"
                  disabled={!checkRolesAuth('ProjectAddress')}
                  value={formData.ProjectAddress}
                  onChange={handleInputChange}
                />
              </FormControl>
            </Grid>
            <Grid size={12}>
              <Divider />
            </Grid>
            <Grid size={2}>
              <FormControl fullWidth>
                <TextField
                  label="Sözleşme Tarihi"
                  variant="outlined"
                  type="date"
                  disabled={!checkRolesAuth('ContractDate')}
                  InputLabelProps={{ shrink: true }}
                  name="ContractDate"
                  value={formData?.ContractDate?.split('T')[0]}
                  onChange={handleInputChange}
                />
              </FormControl>
            </Grid>
            <Grid size={2}>
              <FormControl fullWidth>
                <TextField
                  id="ControlRoomCount"
                  name="ControlRoomCount"
                  variant="outlined"
                  type="number"
                  label="Merkezi Kumanda Sayısı"
                  disabled={!checkRolesAuth('ControlRoomCount')}
                  value={data.filter(x => x.Level === 0 && x.LineStatus !== 'D')
                    .length}
                  onChange={event =>
                    handleInputChange(
                      event,
                      'ChildCount',
                      event.target.value === '' || event.target.value === null
                        ? 0
                        : event.target.value,
                      0,
                      formDataMinValues.ControlRoomCount,
                      -1
                    )
                  }
                />
              </FormControl>
            </Grid>
            <Grid size={2}>
              <FormControl fullWidth>
                <TextField
                  id="SystemCount"
                  name="SystemCount"
                  variant="outlined"
                  type="number"
                  label="Sistem Sayısı"
                  disabled={!checkRolesAuth('SystemCount')}
                  value={
                    data.filter(x => x.Level === 1 && x.LineStatus !== 'D')
                      .length
                  }
                  onChange={event =>
                    handleInputChange(
                      event,
                      'ChildCount',
                      event.target.value === '' || event.target.value === null
                        ? 0
                        : event.target.value,
                      1,
                      formDataMinValues.SystemCount,
                      -1
                    )
                  }
                />
              </FormControl>
            </Grid>
            <Grid size={1}>
              <FormControl fullWidth>
                <TextField
                  variant="outlined"
                  type="number"
                  label="Isı Pompası"
                  name="HeatPumpCount"
                  disabled={!checkRolesAuth('HeatPumpCount')}
                  value={formData.HeatPumpCount}
                  onChange={event => {
                    handleInputChange(
                      event,
                      'decreaseControl',
                      '',
                      '',
                      formDataMinValues.HeatPumpCount
                    );
                  }}
                />
              </FormControl>
            </Grid>
            <Grid size={1}>
              <FormControl fullWidth>
                <TextField
                  id="PdiCount"
                  name="PdiCount"
                  type="number"
                  label="PDI"
                  variant="outlined"
                  disabled={!checkRolesAuth('PdiCount')}
                  value={formData.PdiCount}
                  onChange={event => {
                    handleInputChange(
                      event,
                      'decreaseControl',
                      '',
                      '',
                      formDataMinValues.PdiCount
                    );
                  }}
                />
              </FormControl>
            </Grid>
            <Grid size={1}>
              <FormControl fullWidth>
                <TextField
                  id="FreshAirCount"
                  name="FreshAirCount"
                  type="number"
                  label="Taze Hava"
                  variant="outlined"
                  disabled={!checkRolesAuth('FreshAirCount')}
                  value={formData.FreshAirCount}
                  onChange={event => {
                    handleInputChange(
                      event,
                      'decreaseControl',
                      '',
                      '',
                      formDataMinValues.FreshAirCount
                    );
                  }}
                />
              </FormControl>
            </Grid>
            <Grid size={1}>
              <FormControl fullWidth>
                <TextField
                  id="ProjectTotalOduCount"
                  type="number"
                  name="ProjectTotalOduCount"
                  label="Toplam Odu Adet"
                  variant="outlined"
                  value={
                    data
                      ? data
                        .filter(x => x.Level === 1)
                        .reduce(
                          (total, item) =>
                            total + parseInt(item.OduCount, 10),
                          0
                        )
                      : 0
                  }
                  onChange={handleInputChange}
                  disabled={true}
                />
              </FormControl>
            </Grid>
            <Grid size={1}>
              <FormControl fullWidth>
                <TextField
                  id="ProjectTotalIduCount"
                  variant="outlined"
                  type="number"
                  label="Toplam Idu Adet"
                  name="ProjectTotalIduCount"
                  value={
                    data
                      ? data
                        .filter(x => x.Level === 1)
                        .reduce(
                          (total, item) =>
                            total + parseInt(item.IduCount, 10),
                          0
                        )
                      : 0
                  }
                  onChange={handleInputChange}
                  disabled={true}
                />
              </FormControl>
            </Grid>
            <Grid size={1}>
              <FormControl fullWidth>
                <TextField
                  id="ProjectTotalGasAmount"
                  type="number"
                  name="ProjectTotalGasAmount"
                  label="Proje Toplam Gaz Miktarı"
                  variant="outlined"
                  value={
                    data
                      ? data
                        .filter(x => x.Level === 1)
                        .reduce(
                          (total, item) =>
                            total + parseFloat(item.SystemTotalGas),
                          0
                        )
                      : 0
                  }
                  onChange={handleInputChange}
                  disabled={true}
                />
              </FormControl>
            </Grid>
            <Grid size={12}>
              <FormControl fullWidth>
                <ProjectUpdate
                  data={data}
                  setData={setData}
                  projectFiles={projectFiles}
                  setProjectFiles={setProjectFiles}
                  errors={errors}
                  setErrors={setErrors}
                  checkRolesAuth={checkRolesAuth}
                  fileLoading={fileLoading}
                  setFileLoading={setFileLoading}
                />
              </FormControl>
            </Grid>
            <Grid size={12}>
              <FormControl fullWidth>
                <TextField
                  variant="outlined"
                  multiline
                  minRows={4}
                  placeholder="Açıklama"
                  name="Description"
                  disabled={!checkRolesAuth('Description')}
                  value={formData.Description}
                  onChange={handleInputChange}
                />
              </FormControl>
            </Grid>
            <Grid size={12}>
              <Divider />
            </Grid>
          </Grid>
        ) : (
          <Box sx={{ display: 'flex' }}>
            <CircularProgress
              sx={{
                color: '#ff9800',
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: '-12px',
                marginLeft: '-12px'
              }}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <HavcRadioOption
          name="DraftProject"
          value={formData.DraftProject ? true : false}
          disabled={!checkRolesAuth('DraftProject') || !formData.DraftProject}
          onChange={handleInputChange}
          size="medium"
        />
        {currentUser === '26087698' && (
          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Call</CloseIcon>}
            onClick={() => testFunc()}
            autoFocus
          >
            Log
          </Button>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ m: 1, position: 'relative' }}>
            <Button
              variant="contained"
              color="secondary"
              disabled={
                loading || !HavcAddressData || HavcAddressData?.length === 0
              }
              endIcon={<SaveIcon>Call</SaveIcon>}
              onClick={() => {
                formData.DraftProject ?
                  setKaydet() : setProjectSummary(true)
              }}
              autoFocus
            >
              Kaydet
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  color: '#ff9800',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  marginTop: '-12px',
                  marginLeft: '-12px'
                }}
              />
            )}
          </Box>
        </Box>
        <Button
          variant="contained"
          color="secondary"
          endIcon={<CloseIcon>Call</CloseIcon>}
          onClick={handleDialogClose}
          autoFocus
        >
          Kapat
        </Button>
      </DialogActions>
      {projectSummary && (
        <Dialog
          open={projectSummary}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle id="alert-dialog-title">
            {'Projede oluşacak fiş adetleri'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <ProjectSummaryList data={data} formData={formData} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<CloseIcon></CloseIcon>}
              onClick={() => setProjectSummary(false)}
            >
              Hayır
            </Button>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<CheckIcon></CheckIcon>}
              onClick={() => {
                setProjectSummary(false);
                setKaydet();
              }}
              autoFocus
            >
              Evet
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {showAlert && (
        <Alert severity="error">Zorunlu alanları lütfen doldurunuz!</Alert>
      )}
    </Dialog>
  );
}

export default UpdateProjectDialog;
